// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AxsH","badges":"styles_badges__1-U-w"};